import {wrapCall} from '../utils/serviceUtils';
import {api} from '../services';

import * as types from '../constants/actionTypes';

export const fetchOpportunities = (accountSfid, query) => {
  let url = `/account/${accountSfid}/opportunity?limit=1000`;
  if (query) { url += `&name=${query}`; }
  return wrapCall(
    api.get(url),
    'fetch_opportunities'
  );
};

export const linkOpportunity = (opportunity, dsa) => {
  return wrapCall(
    api.post(`/dsa/${dsa.id}/opportunity/${opportunity.sfid}`),
    'link_opportunity'
  );
};

export const unlinkOpportunity = (opportunity, dsa) => {
  return wrapCall(
    api.delete(`/dsa/${dsa.id}/opportunity/${opportunity.sfid}`),
    'unlink_opportunity'
  );
};

export const salesforceSyncError = (dsa) => {
  return {
    type: types.SALESFORCE_SYNC_ERROR,
    dsa
  };
};



// WEBPACK FOOTER //
// ./src/actions/opportunityActions.js